<template>
  <section class="is-full-screen-height has-background-white">
    <router-view />
  </section>
</template>

<script>
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ReferralSelfReferLayout',
  async beforeRouteEnter(to, from, next) {
    DocumentUIService.removeAppLoader();
    next();
  },
  mounted() {
    document.querySelector('html').classList.add('has-background-white');
  }
};
</script>
